
import { createApp } from "vue";

import { sync } from 'vuex-router-sync'
import App from "./App.vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import directives from './directives'

import store from "./store";
import router from "./router";
// import NProgress from 'vue-nprogress'
import ElementUI from "element-plus";
import locale from 'element-plus/lib/locale/lang/zh-cn'
import * as ElIcons from '@element-plus/icons'

import mitt from 'mitt'
import moment from "moment";
moment.locale("zh-CN");

import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

// import 'nprogress/nprogress.css'
import "element-plus/dist/index.css";
import 'font-awesome/css/font-awesome.css'

import './assets/font/iconfont.css'
import "./assets/iconfont/iconfont.css";
import "./assets/less/darkBlue/index.less";
// import './assets/iconfonts/iconfontpage.css'

import Modal from "@/components/common/Modal";
import RIcon from "@/components/common/RIcon";
import RCell from "@/components/common/RCell";
import Pagination from "@/components/common/Pagination";
import UploadAvatar from "@/components/common/uploadAvatar";
import RzDatePicker from "@/components/common/select/RzDatePicker";
import CollisionTable from "@/components/common/CollisionTable";

import * as echarts from "echarts";

const app = createApp(App);
app.use(VueAxios, axios)
app.provide('axios', app.config.globalProperties.axios)

// 全局注册 element-plus icon
Object.keys(ElIcons).forEach(key => {
  app.component(key, ElIcons[key])
})

sync(store, router)
app.use(store).use(router);
app.use(ElementUI, { locale });

app.component("RIcon", RIcon);
app.component("RCell", RCell);
app.component("Modal", Modal);
app.component("Pagination", Pagination);
app.component("UploadAvatar", UploadAvatar);
app.component("RzDatePicker", RzDatePicker);
app.component("CollisionTable", CollisionTable);

// 添加全局指令
for (let key in directives) {
  app.directive(key, directives[key])
}

app.config.silent = true;
app.config.productionTip = false;

app.config.globalProperties.$echarts = echarts;
app.config.globalProperties.$eventBus = new mitt() // 挂载事件总线
app.config.globalProperties.$filePathUrl = app.axios.defaults.baseURL;

app.mount("#app");
